document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('click', function (e) {
    const toggle = e.target.closest('.header-search-toggle');
    if (!toggle) return;

    e.preventDefault();

    const wrapper = toggle.closest('.header-search-wrapper');
    if (!wrapper) return;

    const header = toggle.closest('.header-main--center-logo');

    wrapper.classList.toggle('is-open');

    if (header) {
      header.classList.toggle('is-search-open');
    }

    if (wrapper.classList.contains('is-open')) {
      wrapper.querySelector('.search-field')?.focus();
    }
  });

  // ESC để đóng search
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document
        .querySelectorAll('.header-search-wrapper.is-open')
        .forEach(wrapper => {
          wrapper.classList.remove('is-open');

          const header = wrapper.closest('.header-main--center-logo');
          if (header) {
            header.classList.remove('is-search-open');
          }
        });
    }
  });
  
  //
  
  document.querySelectorAll('.mobile-toggle-wrapper').forEach(wrapper => {
	  const toggle  = wrapper.querySelector('.mobile-toggle');
	  const overlay = wrapper.querySelector('.overlay-menu');
	  const mobileMenu = document.getElementById('mobile-menu');

	  if (!toggle) return;

	  function closeMenu() {
		wrapper.classList.remove('menu-open');
		document.body.classList.remove('overflow-hidden');

		if (mobileMenu) {
		  mobileMenu.querySelectorAll('details[open]').forEach(d => {
			d.removeAttribute('open');
		  });
		}
	  }

	  toggle.addEventListener('click', function (e) {
		e.preventDefault();

		const isOpen = wrapper.classList.contains('menu-open');

		if (!isOpen) {
		  wrapper.classList.add('menu-open');
		  document.body.classList.add('overflow-hidden');
		} else {
		  closeMenu();
		}
	  });

	  if (overlay) {
		overlay.addEventListener('click', closeMenu);
	  }

	  if (mobileMenu) {
		mobileMenu.querySelectorAll('.mobile-menu-top, .close-menu')
		  .forEach(el => {
			el.addEventListener('click', function (e) {
			  e.preventDefault();
			  closeMenu();
			});
		  });
	  }
	});

	////
	
	const input = document.querySelector('#header-search-input');
	const predictiveBox = document.querySelector('.thb-predictive-search');
	const container = predictiveBox.querySelector('.thb-predictive-search--container');
	const loader = predictiveBox.querySelector('.loading-overlay');
	const selectFilter = document.querySelector('#header-search-select');

	let debounceTimer;

	input.addEventListener('input', () => {
	  clearTimeout(debounceTimer);

	  const q = input.value.trim();
	  if (q.length < 2) {
		predictiveBox.setAttribute('inert', '');
		return;
	  }

	  debounceTimer = setTimeout(() => {
		runSearch(q);
	  }, 300);
	});

	function runSearch(q) {
	  loader.style.display = 'block';
	  predictiveBox.removeAttribute('inert');

	  let url = `/search?q=${encodeURIComponent(q)}&view=ajax`;

	  // Nếu có filter product_type / tag
	  if (selectFilter && selectFilter.value) {
		url += `&${selectFilter.name}=${encodeURIComponent(selectFilter.value)}`;
	  }

	  fetch(url)
		.then(res => res.text())
		.then(html => {
		  container.innerHTML = html;
		})
		.finally(() => {
		  loader.style.display = 'none';
		});
	}
	
	//
	document.addEventListener('click', (e) => {
	  if (!e.target.closest('.header-search-wrapper')) {
		predictiveBox.setAttribute('inert', '');
	  }
	});


	document.querySelectorAll('.js-force-download').forEach(link => {
	link.addEventListener('click', function(e) {
		const url = this.getAttribute('href');
		
		if (url && (url.includes('.pdf') || url.includes('cdn.shopify.com'))) {
		e.preventDefault();
		
		fetch(url)
			.then(response => response.blob())
			.then(blob => {
			const blobUrl = window.URL.createObjectURL(blob);
			const a = document.createElement('a');
			a.style.display = 'none';
			a.href = blobUrl;
			
			// Lấy tên file từ URL hoặc đặt tên mặc định
			const fileName = url.split('/').pop().split('?')[0] || 'document.pdf';
			a.download = fileName;
			
			document.body.appendChild(a);
			a.click();
			
			// Dọn dẹp
			window.URL.revokeObjectURL(blobUrl);
			document.body.removeChild(a);
			})
			.catch(() => {
			// Nếu có lỗi (CORS...), fallback về cách mở link thông thường
			window.location.href = url;
			});
		}
	});
	});
  
});
